import React from 'react';
import './sidebar.css'
import logo from '../../assets/logo.png'
import Navlink from '../common/nav_but';
import pic2 from '../../assets/pic2.png'
import pic3 from '../../assets/pic3.png'
import pic4 from '../../assets/pic4.png'
import pic5 from '../../assets/pic5.png'
import pic6 from '../../assets/pic6.png'
import pic7 from '../../assets/pic7.png'
import pic8 from '../../assets/pic8.png'
import pic9 from '../../assets/pic9.png'
import pic10 from '../../assets/pic10.png'
import pic11 from '../../assets/pic11.png'
import pic12 from '../../assets/pic12.png'
import pic15 from '../../assets/PIC15.png'
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';



const Sidebar = ({ isOpen }) => {


 const location = useLocation();
 

const isContentManagementActive =
  location.pathname === '/content-management-navigations' ||
    location.pathname === '/content-management-home' ||
    location.pathname === '/content-management-Exhibitors' ||
  location.pathname === '/content-management-popups';

    return ( 
        <section className={`sec-cont-side-bar ${isOpen ? 'show' : 'hide'}`} >

        <nav className='sidebar'>
            <article className='box1-side-bar'>
                <img className='logo' src={logo} alt="logo"></img>
            </article>

            <article className='container-profile2'>

                                    
                <figure className='container-img-profile'>
                        <h2 className='text-circle'>S</h2>
                 </figure>
                
                <article className='container-text-profile'>
                        <h2 className='admintext'>Salma Yasser</h2>
                        <h3 className='adminemail'>Administrator</h3>
                </article>
    

                </article>





            <nav className='container-buttons'>

                <Link to="/dashboard"  className="link">
                <Navlink
                    title='Dashboard'
                    alt='Dashboard'
                    img={pic2}
                    stylee={location.pathname === '/dashboard' ? 'activepage-button' : 'noneactivebutton'}
                    stylee2={location.pathname === '/dashboard' ? 'active-text' : 'noneactive-text'}
                />
                </Link>


                <Link to="/event-management"  className="link">
                    <Navlink
                        title="Event Management"
                        img={pic3}
                        alt='Event Management'
                        stylee={location.pathname === '/event-management' ? 'activepage-button' : 'noneactivebutton'}
                        stylee2={location.pathname === '/event-management' ? 'active-text' : 'noneactive-text'}
                    />
                </Link>

        
                <Link to="/booking-management"  className="link">      
                <Navlink title='Booking' img={pic4} 
                alt='Booking'
                stylee={location.pathname === '/booking-management' ? 'activepage-button' : 'noneactivebutton'}
                stylee2={location.pathname === '/booking-management' ? 'active-text' : 'noneactive-text'}/>
             </Link>  


                <Link to=""  className="link">   
                <Navlink title='Users' img={pic5} 
                alt='users'
                stylee={location.pathname === '/' ? 'activepage-button' : 'noneactivebutton'}
                stylee2={location.pathname === '/' ? 'active-text' : 'noneactive-text'}/>
                </Link>

                <Link to=""  className="link">  
                <Navlink title='Messages' img={pic6}
                alt='Messages'
                 stylee={location.pathname === '/' ? 'activepage-button' : 'noneactivebutton'}
                stylee2={location.pathname === '/' ? 'active-text' : 'noneactive-text'}/>
                </Link>



                <Link to="/categories"  className="link">  
                <Navlink title='Categories' img={pic7}
                alt='Categories'
                 stylee={location.pathname === '/categories' ? 'activepage-button' : 'noneactivebutton'}
                stylee2={location.pathname === '/categories' ? 'active-text' : 'noneactive-text'}/>
                </Link>


                <Link to="/Exhibitors-management"  className="link">  
                <Navlink title='Exhibitors' img={pic8} 
                alt='Exhibitors'
                  stylee={location.pathname === '/Exhibitors-management' ? 'activepage-button' : 'noneactivebutton'}
                stylee2={location.pathname === '/Exhibitors-management' ? 'active-text' : 'noneactive-text'}/>
                </Link>

                <Link to=""  className="link">          
                    <Navlink
                    title='Ticket'
                    alt='Ticket'
                    img={pic9}
 stylee={location.pathname === '/' ? 'activepage-button' : 'noneactivebutton'}
                stylee2={location.pathname === '/' ? 'active-text' : 'noneactive-text'}
                    />

                </Link>

                <Link to="/content-management-navigations"  className="link">          
                    <Navlink
                    title='Content Management'
                    img={pic10}
                    alt='content mangement'
                    stylee={isContentManagementActive ? 'activepage-button' : 'noneactivebutton'}

stylee2={isContentManagementActive ? 'active-text' : 'noneactive-text'}
                    />

                </Link>


                <Link to=""  className="link">          
                    <Navlink
                    title='Settings'
                    alt='content settings'
                    img={pic11}
                     stylee={location.pathname === '/' ? 'activepage-button' : 'noneactivebutton'}
                stylee2={location.pathname === '/' ? 'active-text' : 'noneactive-text'}
                    />

                </Link>

                <Link to=""  className="link">          
                    <Navlink
                    title='notification'
                    alt='content notification'
                    img={pic15}
                     stylee= 'nonactive-text-notification'
                     stylee2='noneactive-text'
                    />

                </Link>



            </nav>

             <nav className='container-buttons2'>
         
                 <nav className='container-last-part-sidebar'>
                 <Link to="/" className='link'   >
                <Navlink title='Logout' img={pic12} stylee='noneactivebutton' stylee2='noneactive-text'
                alt='Log out'/>    
                </Link>   

                </nav>

            </nav>








     
            </nav>



        </section>
     );
}
 
export default Sidebar;